import React from "react";
import Profile from "../components/Profile";
import NavBar from "../components/homePage/navBar";

const ProfilePage: React.FC = () => {
    return (
        <div>
            <NavBar />
            <Profile />
        </div>
    )
}

export default ProfilePage;